// =====================================================================================================
//                                    ⚠️ IMPORTANT:
// =====================================================================================================
// - `/unstable` api is DEPRECATED
// - adding new API exports to this file is FORBIDDEN ( except `react-virtualizer` )
// - modifying any existing exports in this file is FORBIDDEN
// - use/consume `*-preview` packages directly for preview/unstable Fluent UI core controls early access
// =====================================================================================================
/* eslint-disable deprecation/deprecation */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Alert: function() {
        return _reactalert.Alert;
    },
    Drawer: function() {
        return _reactdrawer.Drawer;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ DrawerBody: function() {
        return _reactdrawer.DrawerBody;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ DrawerFooter: function() {
        return _reactdrawer.DrawerFooter;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ DrawerHeader: function() {
        return _reactdrawer.DrawerHeader;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ DrawerHeaderNavigation: function() {
        return _reactdrawer.DrawerHeaderNavigation;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ DrawerHeaderTitle: function() {
        return _reactdrawer.DrawerHeaderTitle;
    },
    DrawerInline: function() {
        return /** @deprecated Use `InlineDrawer` from @fluentui/react-components instead */ _reactdrawer.InlineDrawer;
    },
    DrawerInlineClassNames: function() {
        return /** @deprecated Use `InlineDrawerClassNames` from @fluentui/react-components instead */ _reactdrawer.inlineDrawerClassNames;
    },
    DrawerOverlay: function() {
        return /** @deprecated Use `OverlayDrawer` from @fluentui/react-components instead */ _reactdrawer.OverlayDrawer;
    },
    DrawerOverlayClassNames: function() {
        return /** @deprecated Use `OverlayDrawerClassNames` from @fluentui/react-components instead */ _reactdrawer.overlayDrawerClassNames;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ FlatTree: function() {
        return _reacttree.FlatTree;
    },
    InfoButton: function() {
        return _reactinfobutton.InfoButton;
    },
    InfoLabel: function() {
        return _reactinfobutton.InfoLabel;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ InlineDrawer: function() {
        return _reactdrawer.InlineDrawer;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ OverlayDrawer: function() {
        return _reactdrawer.OverlayDrawer;
    },
    Tree: function() {
        return _reacttree.Tree;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ TreeItem: function() {
        return _reacttree.TreeItem;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ TreeItemLayout: function() {
        return _reacttree.TreeItemLayout;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ TreeItemPersonaLayout: function() {
        return _reacttree.TreeItemPersonaLayout;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ TreeItemProvider: function() {
        return _reacttree.TreeItemProvider;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ TreeProvider: function() {
        return _reacttree.TreeProvider;
    },
    Virtualizer: function() {
        return _reactvirtualizer.Virtualizer;
    },
    VirtualizerContextProvider: function() {
        return _reactvirtualizer.VirtualizerContextProvider;
    },
    VirtualizerScrollView: function() {
        return _reactvirtualizer.VirtualizerScrollView;
    },
    VirtualizerScrollViewDynamic: function() {
        return _reactvirtualizer.VirtualizerScrollViewDynamic;
    },
    alertClassNames: function() {
        return _reactalert.alertClassNames;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ drawerBodyClassNames: function() {
        return _reactdrawer.drawerBodyClassNames;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ drawerFooterClassNames: function() {
        return _reactdrawer.drawerFooterClassNames;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ drawerHeaderClassNames: function() {
        return _reactdrawer.drawerHeaderClassNames;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ drawerHeaderNavigationClassNames: function() {
        return _reactdrawer.drawerHeaderNavigationClassNames;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ drawerHeaderTitleClassNames: function() {
        return _reactdrawer.drawerHeaderTitleClassNames;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ flatTreeClassNames: function() {
        return _reacttree.flatTreeClassNames;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ flattenTree_unstable: function() {
        return _reacttree.flattenTree_unstable;
    },
    infoButtonClassNames: function() {
        return _reactinfobutton.infoButtonClassNames;
    },
    infoLabelClassNames: function() {
        return _reactinfobutton.infoLabelClassNames;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ inlineDrawerClassNames: function() {
        return _reactdrawer.inlineDrawerClassNames;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ overlayDrawerClassNames: function() {
        return _reactdrawer.overlayDrawerClassNames;
    },
    renderAlert_unstable: function() {
        return _reactalert.renderAlert_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ renderDrawerBody_unstable: function() {
        return _reactdrawer.renderDrawerBody_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ renderDrawerFooter_unstable: function() {
        return _reactdrawer.renderDrawerFooter_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ renderDrawerHeaderNavigation_unstable: function() {
        return _reactdrawer.renderDrawerHeaderNavigation_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ renderDrawerHeaderTitle_unstable: function() {
        return _reactdrawer.renderDrawerHeaderTitle_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ renderDrawerHeader_unstable: function() {
        return _reactdrawer.renderDrawerHeader_unstable;
    },
    renderDrawerInline_unstable: function() {
        return /** @deprecated Use `renderInlineDrawer_unstable` from @fluentui/react-components instead */ _reactdrawer.renderInlineDrawer_unstable;
    },
    renderDrawerOverlay_unstable: function() {
        return /** @deprecated Use `renderOverlayDrawer_unstable` from @fluentui/react-components instead */ _reactdrawer.renderOverlayDrawer_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ renderDrawer_unstable: function() {
        return _reactdrawer.renderDrawer_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ renderFlatTree_unstable: function() {
        return _reacttree.renderFlatTree_unstable;
    },
    renderInfoButton_unstable: function() {
        return _reactinfobutton.renderInfoButton_unstable;
    },
    renderInfoLabel_unstable: function() {
        return _reactinfobutton.renderInfoLabel_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ renderInlineDrawer_unstable: function() {
        return _reactdrawer.renderInlineDrawer_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ renderOverlayDrawer_unstable: function() {
        return _reactdrawer.renderOverlayDrawer_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ renderTreeItemLayout_unstable: function() {
        return _reacttree.renderTreeItemLayout_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ renderTreeItemPersonaLayout_unstable: function() {
        return _reacttree.renderTreeItemPersonaLayout_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ renderTreeItem_unstable: function() {
        return _reacttree.renderTreeItem_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ renderTree_unstable: function() {
        return _reacttree.renderTree_unstable;
    },
    renderVirtualizerScrollViewDynamic_unstable: function() {
        return _reactvirtualizer.renderVirtualizerScrollViewDynamic_unstable;
    },
    renderVirtualizerScrollView_unstable: function() {
        return _reactvirtualizer.renderVirtualizerScrollView_unstable;
    },
    renderVirtualizer_unstable: function() {
        return _reactvirtualizer.renderVirtualizer_unstable;
    },
    scrollToItemDynamic: function() {
        return _reactvirtualizer.scrollToItemDynamic;
    },
    scrollToItemStatic: function() {
        return _reactvirtualizer.scrollToItemStatic;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ treeClassNames: function() {
        return _reacttree.treeClassNames;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ treeItemClassNames: function() {
        return _reacttree.treeItemClassNames;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ treeItemLayoutClassNames: function() {
        return _reacttree.treeItemLayoutClassNames;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ treeItemLevelToken: function() {
        return _reacttree.treeItemLevelToken;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ treeItemPersonaLayoutClassNames: function() {
        return _reacttree.treeItemPersonaLayoutClassNames;
    },
    useAlertStyles_unstable: function() {
        return _reactalert.useAlertStyles_unstable;
    },
    useAlert_unstable: function() {
        return _reactalert.useAlert_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerBodyStyles_unstable: function() {
        return _reactdrawer.useDrawerBodyStyles_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerBody_unstable: function() {
        return _reactdrawer.useDrawerBody_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerFooterStyles_unstable: function() {
        return _reactdrawer.useDrawerFooterStyles_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerFooter_unstable: function() {
        return _reactdrawer.useDrawerFooter_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerHeaderNavigationStyles_unstable: function() {
        return _reactdrawer.useDrawerHeaderNavigationStyles_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerHeaderNavigation_unstable: function() {
        return _reactdrawer.useDrawerHeaderNavigation_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerHeaderStyles_unstable: function() {
        return _reactdrawer.useDrawerHeaderStyles_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerHeaderTitleStyles_unstable: function() {
        return _reactdrawer.useDrawerHeaderTitleStyles_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerHeaderTitle_unstable: function() {
        return _reactdrawer.useDrawerHeaderTitle_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawerHeader_unstable: function() {
        return _reactdrawer.useDrawerHeader_unstable;
    },
    useDrawerInlineStyles_unstable: function() {
        return /** @deprecated Use `useInlineDrawerStyles_unstable` from @fluentui/react-components instead */ _reactdrawer.useInlineDrawerStyles_unstable;
    },
    useDrawerInline_unstable: function() {
        return /** @deprecated Use `useInlineDrawer_unstable` from @fluentui/react-components instead */ _reactdrawer.useInlineDrawer_unstable;
    },
    useDrawerOverlayStyles_unstable: function() {
        return /** @deprecated Use `useOverlayDrawerStyles_unstable` from @fluentui/react-components instead */ _reactdrawer.useOverlayDrawerStyles_unstable;
    },
    useDrawerOverlay_unstable: function() {
        return /** @deprecated Use `useOverlayDrawer_unstable` from @fluentui/react-components instead */ _reactdrawer.useOverlayDrawer_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useDrawer_unstable: function() {
        return _reactdrawer.useDrawer_unstable;
    },
    useDynamicVirtualizerMeasure: function() {
        return _reactvirtualizer.useDynamicVirtualizerMeasure;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useFlatTreeContextValues_unstable: function() {
        return _reacttree.useFlatTreeContextValues_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useFlatTreeStyles_unstable: function() {
        return _reacttree.useFlatTreeStyles_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useFlatTree_unstable: function() {
        return _reacttree.useFlatTree_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useHeadlessFlatTree_unstable: function() {
        return _reacttree.useHeadlessFlatTree_unstable;
    },
    useInfoButtonStyles_unstable: function() {
        return _reactinfobutton.useInfoButtonStyles_unstable;
    },
    useInfoButton_unstable: function() {
        return _reactinfobutton.useInfoButton_unstable;
    },
    useInfoLabelStyles_unstable: function() {
        return _reactinfobutton.useInfoLabelStyles_unstable;
    },
    useInfoLabel_unstable: function() {
        return _reactinfobutton.useInfoLabel_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useInlineDrawerStyles_unstable: function() {
        return _reactdrawer.useInlineDrawerStyles_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useInlineDrawer_unstable: function() {
        return _reactdrawer.useInlineDrawer_unstable;
    },
    useIntersectionObserver: function() {
        return _reactvirtualizer.useIntersectionObserver;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useOverlayDrawerStyles_unstable: function() {
        return _reactdrawer.useOverlayDrawerStyles_unstable;
    },
    /** @deprecated Drawer is currently stable. Import from @fluentui/react-components instead */ useOverlayDrawer_unstable: function() {
        return _reactdrawer.useOverlayDrawer_unstable;
    },
    useResizeObserverRef_unstable: function() {
        return _reactvirtualizer.useResizeObserverRef_unstable;
    },
    useStaticVirtualizerMeasure: function() {
        return _reactvirtualizer.useStaticVirtualizerMeasure;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeContextValues_unstable: function() {
        return _reacttree.useTreeContextValues_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeContext_unstable: function() {
        return _reacttree.useTreeContext_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeItemContextValues_unstable: function() {
        return _reacttree.useTreeItemContextValues_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeItemContext_unstable: function() {
        return _reacttree.useTreeItemContext_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeItemLayoutStyles_unstable: function() {
        return _reacttree.useTreeItemLayoutStyles_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeItemLayout_unstable: function() {
        return _reacttree.useTreeItemLayout_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeItemPersonaLayoutStyles_unstable: function() {
        return _reacttree.useTreeItemPersonaLayoutStyles_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeItemPersonaLayout_unstable: function() {
        return _reacttree.useTreeItemPersonaLayout_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeItemStyles_unstable: function() {
        return _reacttree.useTreeItemStyles_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeItem_unstable: function() {
        return _reacttree.useTreeItem_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTreeStyles_unstable: function() {
        return _reacttree.useTreeStyles_unstable;
    },
    /** @deprecated Tree is currently stable. Import from @fluentui/react-components instead */ useTree_unstable: function() {
        return _reacttree.useTree_unstable;
    },
    useVirtualizerContext_unstable: function() {
        return _reactvirtualizer.useVirtualizerContext_unstable;
    },
    useVirtualizerScrollViewDynamicStyles_unstable: function() {
        return _reactvirtualizer.useVirtualizerScrollViewDynamicStyles_unstable;
    },
    useVirtualizerScrollViewDynamic_unstable: function() {
        return _reactvirtualizer.useVirtualizerScrollViewDynamic_unstable;
    },
    useVirtualizerScrollViewStyles_unstable: function() {
        return _reactvirtualizer.useVirtualizerScrollViewStyles_unstable;
    },
    useVirtualizerScrollView_unstable: function() {
        return _reactvirtualizer.useVirtualizerScrollView_unstable;
    },
    useVirtualizerStyles_unstable: function() {
        return _reactvirtualizer.useVirtualizerStyles_unstable;
    },
    useVirtualizer_unstable: function() {
        return _reactvirtualizer.useVirtualizer_unstable;
    },
    virtualizerClassNames: function() {
        return _reactvirtualizer.virtualizerClassNames;
    },
    virtualizerScrollViewClassNames: function() {
        return _reactvirtualizer.virtualizerScrollViewClassNames;
    },
    virtualizerScrollViewDynamicClassNames: function() {
        return _reactvirtualizer.virtualizerScrollViewDynamicClassNames;
    }
});
const _reactalert = require("@fluentui/react-alert");
const _reactinfobutton = require("@fluentui/react-infobutton");
const _reactvirtualizer = require("@fluentui/react-virtualizer");
const _reacttree = require("@fluentui/react-tree");
const _reactdrawer = require("@fluentui/react-drawer");
